// extracted by mini-css-extract-plugin
module.exports = {"stackcard":"mypoints_stackcard__2BLrz","mypointscircle":"mypoints_mypointscircle__3rOfH"};